export const CHECKOUT_URL = 'https://pasteleria.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/3xpy7qRE2QnHv1FX57uTBS/Imagen_de_ChatGPT_8_oct_2026,_19_11_56.png'

export const PRODUCT_NAME = 'MEGA PACK PASTELERÍA DESDE CERO PARA EMPRENDER'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardás recetas de tortas, brownies, alfajores, rellenos y decoraciones, pero cada video explica algo diferente y terminás sin saber cómo organizar todo lo que aprendés.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'Bizcochuelos, masas, cremas, coberturas, decoración, costos, precios, ventas... hay tantas recetas y técnicas que empezar parece complicado.',
  },
  {
    icon: 'map' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés aprender pastelería y comenzar a vender tus propias preparaciones, pero necesitás un camino que vaya desde las recetas básicas hasta la producción y la organización de tu emprendimiento.',
  },
  {
    icon: 'hourglass' as const,
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés comenzar, pero pasan las semanas y continuás guardando recetas en lugar de avanzar con un método organizado que puedas aplicar desde tu cocina.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'chef' as const,
    title: 'FUNDAMENTOS DE PASTELERÍA DESDE CERO',
    desc: 'Aprendé a utilizar utensilios, conocer ingredientes, realizar mediciones, controlar el horno, aplicar técnicas básicas y preparar tus primeras recetas con un método organizado.',
  },
  {
    icon: 'wheat' as const,
    title: 'MASAS, BIZCOCHUELOS Y BASES DE PASTELERÍA',
    desc: 'Aprendé a preparar bizcochuelos, budines, masas dulces, bases para tartas y alfajores, comprendiendo proporciones, técnicas de horneado y errores frecuentes.',
  },
  {
    icon: 'cream' as const,
    title: 'RELLENOS, CREMAS Y COBERTURAS PROFESIONALES',
    desc: 'Descubrí cómo preparar crema pastelera, chantilly, ganache, buttercream, almíbares y rellenos para tortas, aprendiendo técnicas de preparación, aplicación y conservación.',
  },
  {
    icon: 'cake' as const,
    title: 'TORTAS DECORADAS Y TÉCNICAS DE PRESENTACIÓN',
    desc: 'Aprendé a nivelar, rellenar, armar y decorar tortas, utilizar mangas pasteleras, realizar coberturas y conseguir presentaciones atractivas para diferentes celebraciones.',
  },
  {
    icon: 'cookie' as const,
    title: 'PRODUCTOS DE PASTELERÍA PARA VENDER',
    desc: 'Aprendé a preparar brownies, alfajores, cookies, cupcakes, budines, tartas y postres individuales, organizando productos y presentaciones para ofrecer a tus clientes.',
  },
  {
    icon: 'store' as const,
    title: 'CÓMO EMPRENDER Y VENDER PASTELERÍA DESDE CASA',
    desc: 'Aprendé a calcular costos, establecer precios, organizar pedidos, preparar un catálogo, utilizar Instagram y WhatsApp y comenzar a estructurar tu emprendimiento pastelero.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'book' as const,
    title: '100 RECETAS DE PASTELERÍA PARA PREPARAR Y VENDER™',
    desc: 'Una colección de recetas para ampliar tus conocimientos y preparar bizcochuelos, budines, alfajores, cookies, brownies, cupcakes, tartas, postres y otras especialidades.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'calculator' as const,
    title: 'CALCULADORA DE COSTOS, PRECIOS Y GANANCIAS™',
    desc: 'Fórmulas, ejemplos y plantillas para aprender a calcular ingredientes, mano de obra, gastos, precios de venta, márgenes y resultados de cada producto.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'gift' as const,
    title: '30 COMBOS Y CAJAS DULCES PARA VENDER™',
    desc: '30 propuestas de cajas dulces, meriendas, regalos y combos para cumpleaños, celebraciones y fechas especiales, con ideas de cantidades y presentación.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'phone' as const,
    title: 'PLANTILLAS DE CATÁLOGO, REDES SOCIALES Y WHATSAPP™',
    desc: 'Modelos de catálogos, publicaciones, historias, mensajes comerciales y formularios de pedidos para organizar la comunicación y presentar tus productos.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'shield' as const,
    title: 'GUÍA DE CONSERVACIÓN, HIGIENE Y PRESENTACIÓN PROFESIONAL™',
    desc: 'Buenas prácticas para manipular ingredientes, conservar preparaciones, elegir envases, informar alérgenos y entregar productos de manera segura y profesional.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'compass' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de saltar entre recetas y tutoriales. Seguí una ruta organizada desde los ingredientes básicos hasta las preparaciones, la decoración y la venta.',
  },
  {
    icon: 'chef' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Aprendé a preparar bizcochuelos, masas, rellenos, coberturas, tortas, brownies, alfajores y productos para vender con explicaciones paso a paso.',
  },
  {
    icon: 'bulb' as const,
    title: 'COMPRENDÉ LO QUE ESTÁS PREPARANDO',
    desc: 'Empezá a entender cómo funcionan los ingredientes, las proporciones, las técnicas y los tiempos de elaboración para mejorar tus preparaciones y reconocer errores.',
  },
  {
    icon: 'trending' as const,
    title: 'UNA NUEVA OPORTUNIDAD',
    desc: 'Construí conocimientos que pueden convertirse en el primer paso para preparar productos por encargo, ofrecer cajas dulces y desarrollar tu propio emprendimiento.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Arranqué sin saber ni prender bien el horno. Seguí los tomos en orden y en un mes ya hacía bizcochuelos que no se me hundían. Hoy preparo budines y alfajores para la escuela de mis hijos y las otras mamás me empezaron a encargar.',
    author: 'Valeria Gómez',
    role: 'Mamá y emprendedora, 34 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Tenía cientos de recetas guardadas en el celular y nunca terminaba ninguna. Lo que más me sirvió fue el tomo de rellenos y cremas: por fin entendí por qué se me cortaba la ganache. Ya armé mis primeras tortas para cumpleaños de la familia.',
    author: 'Romina Sosa',
    role: 'Empleada administrativa, 41 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Vendía brownies a ojo y sentía que no ganaba nada. Con la calculadora de costos me di cuenta de que estaba cobrando menos de lo que gastaba. Ajusté los precios, ordené los pedidos y ahora sí veo ganancia a fin de mes.',
    author: 'Natalia Ferreyra',
    role: 'Emprendedora pastelera, 29 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Siempre me gustó cocinar, pero nunca me animé a vender. Las propuestas de cajas dulces me dieron ideas para el Día de la Madre y vendí más de veinte. Es la primera vez que siento que esto puede ser un ingreso extra de verdad.',
    author: 'Patricia Medina',
    role: 'Docente jubilada, 52 años',
    location: 'Buenos Aires, Argentina',
  },
  {
    quote:
      'Las plantillas para WhatsApp e Instagram me cambiaron todo. Antes respondía los pedidos como podía y se me mezclaban. Ahora tengo un catálogo lindo, un formulario de pedidos y mis clientas me dicen que se ve todo muy profesional.',
    author: 'Lucía Herrera',
    role: 'Estudiante y pastelera, 26 años',
    location: 'La Plata, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza desde los fundamentos y avanza progresivamente.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Recetas, técnicas de pastelería, rellenos, decoración, productos para vender y organización de un emprendimiento.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Los tomos contienen ejemplos y actividades prácticas.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos en el Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un solo pago, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso es digital después de confirmarse el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'Es material educativo. No reemplaza certificaciones, habilitaciones ni requisitos sanitarios aplicables.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés estudiar el material según tus tiempos.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés comunicarte a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Carolina Paz', city: 'Córdoba', minutes: 2 },
  { name: 'Mariela Godoy', city: 'Rosario', minutes: 5 },
  { name: 'Sofía Martínez', city: 'Buenos Aires', minutes: 8 },
  { name: 'Andrea Villalba', city: 'Mendoza', minutes: 12 },
  { name: 'Julieta Ríos', city: 'La Plata', minutes: 16 },
  { name: 'Gabriela Núñez', city: 'Mar del Plata', minutes: 20 },
  { name: 'Florencia Aguirre', city: 'Salta', minutes: 25 },
  { name: 'Verónica Luna', city: 'San Miguel de Tucumán', minutes: 30 },
]
